import {
    CLEAR_RESTRICTIONS,
    LOAD_RESTRICTIONS_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_RESTRICTIONS_SUCCESS:
            return action.payload;
        case CLEAR_RESTRICTIONS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/systemControl/RestrictionsReducer.js